[
  {
    "id": 0,
    "value": "None"
  },
  {
    "id": 1,
    "value": "String",
    "icon": "mdiFormatTitle"
  },
  {
    "id": 2,
    "value": "Int",
    "icon": "mdiNumeric"
  },
  {
    "id": 3,
    "value": "Boolean",
    "icon": "mdiToggleSwitchOutline"
  },
  {
    "id": 4,
    "value": "OpenList",
    "icon": "mdiFormatListBulleted"
  },
  {
    "id": 5,
    "value": "OpenListMultiple",
    "icon": "mdiFormatListChecks"
  },
  {
    "id": 8,
    "value": "DateTime",
    "icon": "mdiCalendarMonthOutline"
  },
  {
    "id": 9,
    "value": "Money",
    "icon": "mdiCurrencyEur"
  },
  {
    "id": 10,
    "value": "Decimal",
    "icon": "mdiNumeric"
  }
]